const BACKEND_URL = window.__BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const fallbackSnapshot = {
  valuation: null,
  valuation_mode: null,
  mrr: null,
  arr: null,
  growth_status: null,
  activation_rate: null,
  content_throughput: null,
  churn_proxy: null,
  system_reliability: null,
  key_drivers: [],
  change_log: []
};

export async function getAppAnalyticsSnapshot() {
  const snapshot = { ...fallbackSnapshot };

  try {
    const valuationRes = await fetch(`${API}/admin/valuation`, { credentials: 'include' });
    if (valuationRes.ok) {
      const valuationData = await valuationRes.json();
      snapshot.valuation = valuationData?.valuation ?? valuationData?.valuation_proxy ?? null;
      snapshot.valuation_mode = valuationData?.mode ?? valuationData?.valuation_mode ?? null;
      snapshot.mrr = valuationData?.mrr ?? null;
      snapshot.arr = valuationData?.arr ?? null;
      snapshot.growth_status = valuationData?.growth_status ?? null;
      snapshot.activation_rate = valuationData?.activation_rate ?? null;
      snapshot.content_throughput = valuationData?.content_throughput ?? null;
      snapshot.churn_proxy = valuationData?.churn_proxy ?? null;
      snapshot.key_drivers = Array.isArray(valuationData?.key_drivers)
        ? valuationData.key_drivers
        : snapshot.key_drivers;
      snapshot.change_log = Array.isArray(valuationData?.change_log)
        ? valuationData.change_log
        : snapshot.change_log;
    }
  } catch (error) {
    console.error('Error fetching valuation snapshot:', error);
  }

  try {
    const systemRes = await fetch(`${API}/admin/system-health`, { credentials: 'include' });
    if (systemRes.ok) {
      const systemData = await systemRes.json();
      snapshot.system_reliability = systemData?.backend_status || systemData?.overall_status || null;
    }
  } catch (error) {
    console.error('Error fetching system health snapshot:', error);
  }

  return snapshot;
}
